// @flow
import * as Cookie from 'app/packages/cookie-utils';

// TODO(Yen): consolidate this with mobile web error logger and desktop LogToServer
function serializeParam(data) {
  return Object.keys(data)
    .map((key) => key + '=' + encodeURIComponent(data[key]))
    .join('&');
}

export function logToServer(errorData: Object) {
  const reportUrl = '/_/_/report/error/';
  const reportContext = {
    current_url: window.location.href,
  };

  let reportData;
  try {
    reportData = JSON.stringify({ errorObj: errorData });
  } catch (error) {
    const stringifyError = {
      message: errorData.message,
      name: 'logToServer stringify exception',
    };
    reportData = JSON.stringify({ errorObj: stringifyError });
  }

  const data = {
    report_context: JSON.stringify(reportContext),
    report_data: reportData,
  };

  const xhr = new XMLHttpRequest();
  const csrfToken = Cookie.get('csrftoken');
  xhr.open('post', reportUrl, true);
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhr.setRequestHeader('X-CSRFToken', csrfToken || '');
  xhr.send(serializeParam(data));
}

export default undefined;
